import { Department } from '@/features/departments/types/department'

export enum UserRole {
  Admin = 'Admin',
  Maintainer = 'Maintainer',
  User = 'User',
  Vendor = 'Vendor',
}

export type User = {
  id: string
  name: string
  username: string
  role: UserRole
  avatarId: string | null
  primaryDepartmentId?: string | null
  primaryDepartmentName: string
}

export type UserDetail = {
  id: string
  name: string
  username: string
  role: UserRole
  avatarId?: string | null
  primaryDepartment?: Department | null
  departments: Department[]
}

export type CreateUserModel = {
  username: string
  password: string
  name: string
  avatarId?: string | null
  role: string
  primaryDepartmentId?: string | null
}

export type UpdateUserDepartmentsModel = {
  departmentIds: string[]
  primaryDepartmentId?: string | null
}
